import React, { useEffect, useState } from "react";
import Loading from "./loading.js";
import { secretKey, monthData } from "./data";
import AddHolidayPopUp from "./addHoliday.js";
import AcceptHoliday from "./acceptHoliday.js";

const Holidays = (props) => {
  const [monthName, setMonthName] = useState("");
  const [dateC, setDateC] = useState(
    new Date().getFullYear() +
      "-" +
      (new Date().getMonth() < 9
        ? "0" + (new Date().getMonth() + 1)
        : new Date().getMonth() + 1) +
      "-" +
      (new Date().getDate() < 10
        ? "0" + new Date().getDate()
        : new Date().getDate())
  );
  const [holiday, setHoliday] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAddHoliday, setShowAddHoliday] = useState(false);
  const [showEditHoliday, setShowEditHoliday] = useState(false);
  const [showEditPenalty, setShowEditPenalty] = useState(false);
  const [showEditHolidayId, setShowEditHolidayId] = useState(false);
  const [showAddPenalty, setShowAddPenalty] = useState(false);
  const [showAcceptHoliday, setShowAcceptHoliday] = useState(false);
  const [holidaysData, setHolidaysData] = useState([]);

  const addDays = (date, days) => {
    var dateN = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    dateN.setDate(dateN.getDate() + days);
    return dateN;
  };

  const getMonthData = (monthNum) => {
    var data = monthData.filter((el) => +el.id === monthNum);
    return data.length > 0 ? data[0].name : "";
  };

  const getDateOfWeek = (w, y) => {
    var d = 1 + (w - 1) * 7;
    if (new Date(y, 0, d).getFullYear() === 2023) {
      return new Date(y, 0, d + 1);
    } else {
      return new Date(y, 0, d);
    }
  };

  const createMonthSet = () => {
    var date = dateC;
    var year = new Date(date).getFullYear();
    var month = new Date(date).getMonth() + 1;
    var begin = new Date(year, month - 1, 1);
    var end = new Date(year, month, 0);
    var startYear = new Date(date).getFullYear();
    var yearStartDate = new Date(new Date(date).getFullYear(), 0, 1);
    var days = Math.floor((begin - yearStartDate) / (24 * 60 * 60 * 1000));
    var weekNumber = 0;
    if (
      new Date(
        new Date(date).getFullYear(),
        new Date(date).getMonth(),
        1
      ).getDay() === 1
    ) {
      weekNumber = Math.ceil(days / 7) + 1;
    } else {
      weekNumber = Math.ceil(days / 7);
    }
    var daysEnd = Math.floor((end - yearStartDate) / (24 * 60 * 60 * 1000));
    var weekNumberEnd = Math.ceil(daysEnd / 7);
    var startDate = getDateOfWeek(weekNumber, startYear);
    var endDate = addDays(getDateOfWeek(weekNumberEnd, startYear), 6);

    var lastDay = end.getDate();
    var daysArray = [];
    var beginCounter = startDate;
    while (beginCounter >= startDate && beginCounter <= endDate) {
      daysArray.push(
        `${beginCounter.getFullYear()}-${
          beginCounter.getMonth() < 9
            ? "0" + (beginCounter.getMonth() + 1)
            : beginCounter.getMonth() + 1
        }-${beginCounter.getDate()}`
      );
      beginCounter.setDate(beginCounter.getDate() + 1);
    }

    return daysArray;
  };

  const fetchHolidays = async () => {
    var body = {};

    await fetch("https://apisplit.ftpeople.pl/getHolidays", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setHolidaysData(data);
        fetchUsers();
      })
      .catch((error) => {});
  };

  const fetchUsers = async () => {
    var body = {};

    await fetch("https://apisplit.ftpeople.pl/getUsers", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setUsers(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    var date = dateC;
    var year = new Date(date).getFullYear();
    var month = new Date(date).getMonth() + 1;
    setMonthName(getMonthData(month) + " " + year);
    fetchHolidays();
  };

  const getDataDate = (dateX) => {
    setLoading(true);
    var date = dateX;
    var year = new Date(date).getFullYear();
    var month = new Date(date).getMonth() + 1;
    setMonthName(getMonthData(month) + " " + year);
    fetchHolidays();
  };

  useEffect(() => {
    getData();
  }, []);

  const getHoliday = (date) => {
    if (
      new Date(date).getDay() === 6 ||
      new Date(date).getDay() === 0 ||
      checkFreeDay(date)
    ) {
      return [];
    }

    var holidays = holidaysData.filter(
      (el) =>
        date >= new Date(el.date_from).setHours(0) &&
        date <= new Date(el.date_to) &&
        el.type === "Urlop"
    );
    return holidays;
  };

  const getPenalties = (date) => {
    if (
      new Date(date).getDay() === 6 ||
      new Date(date).getDay() === 0 ||
      checkFreeDay(date)
    ) {
      return [];
    }

    var holidays = holidaysData.filter(
      (el) =>
        date >= new Date(el.date_from).setHours(0) &&
        date <= new Date(el.date_to) &&
        el.type === "Kara"
    );
    return holidays;
  };

  const checkFreeDay = (date) => {
    return false;
  };

  const scrollBox = (e) => {
    const divToScrollTo = document.getElementById("cb" + e.target.value);
    divToScrollTo.scrollTo({
      top: divToScrollTo.scrollTop + 100,
      behavior: "smooth",
    });
  };

  const subtractMonths = (numOfMonths) => {
    var newDate = new Date(dateC);
    var retDate = new Date(newDate.setMonth(newDate.getMonth() - numOfMonths));
    setDateC(
      new Date(retDate).getFullYear() +
        "-" +
        (new Date(retDate).getMonth() < 9
          ? "0" + (new Date(retDate).getMonth() + 1)
          : new Date(retDate).getMonth() + 1) +
        "-" +
        (new Date(retDate).getDate() < 10
          ? "0" + new Date(retDate).getDate()
          : new Date(retDate).getDate())
    );
    getDataDate(
      new Date(retDate).getFullYear() +
        "-" +
        (new Date(retDate).getMonth() < 9
          ? "0" + (new Date(retDate).getMonth() + 1)
          : new Date(retDate).getMonth() + 1) +
        "-" +
        (new Date(retDate).getDate() < 10
          ? "0" + new Date(retDate).getDate()
          : new Date(retDate).getDate())
    );
  };

  const addMonths = (numOfMonths) => {
    var newDate = new Date(dateC);
    var retDate = new Date(newDate.setMonth(newDate.getMonth() + numOfMonths));
    setDateC(
      new Date(retDate).getFullYear() +
        "-" +
        (new Date(retDate).getMonth() < 9
          ? "0" + (new Date(retDate).getMonth() + 1)
          : new Date(retDate).getMonth() + 1) +
        "-" +
        (new Date(retDate).getDate() < 10
          ? "0" + new Date(retDate).getDate()
          : new Date(retDate).getDate())
    );
    getDataDate(
      new Date(retDate).getFullYear() +
        "-" +
        (new Date(retDate).getMonth() < 9
          ? "0" + (new Date(retDate).getMonth() + 1)
          : new Date(retDate).getMonth() + 1) +
        "-" +
        (new Date(retDate).getDate() < 10
          ? "0" + new Date(retDate).getDate()
          : new Date(retDate).getDate())
    );
  };

  const setDate = (e) => {
    setLoading(true);

    if (e.target.value === "next") {
      addMonths(1);
    } else if (e.target.value === "previous") {
      subtractMonths(1);
    }
  };

  const calendarMonthNew = (
    <>
      <>
        {loading ? (
          <Loading id="popUpLoading" />
        ) : (
          <>
            {showAddHoliday ? (
              <>
                <AddHolidayPopUp
                  close={() => {
                    setShowAddHoliday(false);
                    getData();
                  }}
                  type="Urlop"
                  user={props.user}
                  users={users}
                  holidaysData={holidaysData}
                />
              </>
            ) : (
              ""
            )}
            {showAcceptHoliday ? (
              <>
                <AcceptHoliday
                  close={() => {
                    setShowAcceptHoliday(false);
                    getData();
                  }}
                  type="Urlop"
                  user={props.user}
                  users={users}
                  holidaysData={holidaysData.filter(
                    (el) => el.status === "REPORTED"
                  )}
                />
              </>
            ) : (
              ""
            )}
            {showEditHoliday ? (
              <>
                <AddHolidayPopUp
                  close={() => {
                    setShowEditHoliday(false);
                    getData();
                  }}
                  mode={"edit"}
                  holiday={
                    holidaysData.filter(
                      (el) => +el.id === +showEditHolidayId
                    )[0]
                  }
                  type="Urlop"
                  user={props.user}
                  users={users}
                  holidaysData={holidaysData.filter(
                    (el) => +el.id !== +showEditHolidayId
                  )}
                />
              </>
            ) : (
              ""
            )}
            {showEditPenalty ? (
              <>
                <AddHolidayPopUp
                  close={() => {
                    setShowEditPenalty(false);
                    getData();
                  }}
                  mode={"edit"}
                  holiday={
                    holidaysData.filter(
                      (el) => +el.id === +showEditHolidayId
                    )[0]
                  }
                  type="Kara"
                  user={props.user}
                  users={users}
                  holidaysData={holidaysData.filter(
                    (el) => +el.id !== +showEditHolidayId
                  )}
                />
              </>
            ) : (
              ""
            )}
            {showAddPenalty ? (
              <>
                <AddHolidayPopUp
                  close={() => {
                    setShowAddPenalty(false);
                    getData();
                  }}
                  type="Kara"
                  user={props.user}
                  users={users}
                  holidaysData={holidaysData}
                />
              </>
            ) : (
              ""
            )}
            <div className="navigationCalendar">
              <>
                <div className="sectionTitleCalendar" style={{ width: "20vw" }}>
                  {monthName}
                </div>
                <button
                  className="navigationArrow"
                  value="previous"
                  onClick={setDate}
                >
                  &#8592;
                </button>
                <button
                  className="navigationArrow"
                  value="next"
                  onClick={setDate}
                >
                  &#8594;
                </button>
              </>
            </div>
            <div className="rowCalendar">
              {createMonthSet().map((el) => (
                <>
                  <div key={el} className="cellCalendar">
                    <div
                      id={
                        "cb" + new Date(el).getMonth() + new Date(el).getDate()
                      }
                      style={{ overflowY: "scroll", height: "18vh" }}
                      className="cellBox"
                    >
                      {getHoliday(new Date(el)).map((el2) => (
                        <>
                          <>
                            <button
                              key={el2.id}
                              style={
                                el2.status === "REPORTED"
                                  ? {
                                      backgroundColor: "red",
                                      color: "white",
                                      borderRadius: "5px",
                                      border: "white",
                                      marginBottom: "5px",
                                      minHeight: "5vh",
                                    }
                                  : {
                                      backgroundColor: "green",
                                      color: "white",
                                      borderRadius: "5px",
                                      border: "white",
                                      marginBottom: "5px",
                                      minHeight: "5vh",
                                    }
                              }
                              id="monthLink"
                              className="caseLink"
                              value={el2.id}
                              onClick={(e) => {
                                if (
                                  (props.user.role === "admin"
                                    ? true
                                    : el2.status !== "ACCEPTED") &&
                                  (props.user.role === "admin"
                                    ? true
                                    : el2.user === props.user.name)
                                ) {
                                  setShowEditHoliday(true);
                                  setShowEditHolidayId(e.currentTarget.value);
                                }
                              }}
                            >
                              <div className="titleBox">
                                <div
                                  id="titleHoliday"
                                  className="titleBox_col1"
                                >
                                  Urlop {el2.user}
                                </div>
                              </div>
                            </button>
                          </>
                        </>
                      ))}

                      {props.user.role === "admin"
                        ? getPenalties(new Date(el)).map((el2) => (
                            <>
                              <>
                                <button
                                  key={el2.id}
                                  style={{
                                    backgroundColor: "orange",
                                    color: "black",
                                    borderRadius: "5px",
                                    border: "white",
                                    marginBottom: "5px",
                                    minHeight: "5vh",
                                  }}
                                  id="monthLink"
                                  className="caseLink"
                                  value={el2.id}
                                  onClick={(e) => {
                                    setShowEditPenalty(true);
                                    setShowEditHolidayId(e.currentTarget.value);
                                  }}
                                >
                                  <div className="titleBox">
                                    <div
                                      id="titleHoliday"
                                      className="titleBox_col1"
                                    >
                                      Kara {el2.user}
                                    </div>
                                  </div>
                                </button>{" "}
                              </>
                            </>
                          ))
                        : ""}
                    </div>
                    <div className="weekSpecialBoxB">
                      {getPenalties(new Date(el)).length +
                        getHoliday(new Date(el)).length >
                      4 ? (
                        <button
                          value={
                            new Date(el).getMonth().toString() +
                            new Date(el).getDate().toString()
                          }
                          onClick={scrollBox}
                          className="moreButtonCalendar"
                        >
                          ▼
                        </button>
                      ) : (
                        ""
                      )}
                    </div>
                    <span className="cellDayNumber">{el}</span>
                  </div>
                </>
              ))}
            </div>
          </>
        )}
      </>
    </>
  );

  return (
    <>
      <div style={{ padding: "20px" }}>
        <div style={{ display: "flex", gap: "20px" }}>
          <button
            style={{
              borderRadius: "5px",
              border: "1px solid white",
              width: "100%",
              height: "3vh",
              backgroundColor: "black",
              cursor: "pointer",
              margin: "1vh 0",
              fontWeight: "600",
              fontSize: "1vw",
              color: "white",
            }}
            value="holiday"
            onClick={() => {
              setShowAddHoliday(true);
            }}
          >
            Dodaj urlop
          </button>
          {props.user.role === "admin" ? (
            <>
              <button
                style={{
                  borderRadius: "5px",
                  border: "1px solid white",
                  width: "100%",
                  height: "3vh",
                  backgroundColor: "black",
                  cursor: "pointer",
                  margin: "1vh 0",
                  fontWeight: "600",
                  fontSize: "1vw",
                  color: "white",
                }}
                value="holiday"
                onClick={() => {
                  setShowAddPenalty(true);
                }}
              >
                Dodaj karę
              </button>

              <button
                style={{
                  borderRadius: "5px",
                  border: "1px solid white",
                  width: "100%",
                  height: "3vh",
                  backgroundColor: "black",
                  cursor: "pointer",
                  margin: "1vh 0",
                  fontWeight: "600",
                  fontSize: "1vw",
                  color: "white",
                }}
                value="remote"
                onClick={() => {
                  setShowAcceptHoliday(true);
                }}
              >
                Wnioski urlopowe do akceptacji
              </button>
            </>
          ) : (
            ""
          )}
        </div>
        {loading ? <Loading /> : calendarMonthNew}
      </div>
    </>
  );
};

export default Holidays;
